$(function () {
    
    $(document).on("keyup", "#txtTripSelectSearch", function () { refrehTripSelectList(); })
     
    function refrehTripSelectList() {

        element_Blur("#tripselectlist", true)

        var val = $("#txtTripSelectSearch").val()
        //ignore value search when less then 3 chars
        if (val.length < 3) { val = ""; }
      
        var clientid = $(".trip-select-table").data("client-id");     

        var req = {
            Value: val
        };

        
        var DTO = { 'Req': req };
        DynaProxy.invoke("GetTripSelect", DTO, function (data) {           
            $("#trip-select-body").html(data);
            element_Blur("#tripselectlist", false);           

        }, function (data) {
            showSupportNotification('Unable to get Trips.');
            element_Blur("#tripselectlist", false)
        });
        return false;
    }

    $(document).on("click", "#trip-select-body td", function (e) {

        e.preventDefault();      
        var hdnSelectMode=   $("#hdnSelectMode").val();         
        var hdnSelectPlaceId=   $("#hdnSelectPlaceId").val(); 
        var hdnSelectPlaceType=  $("#hdnSelectPlaceType").val();                    
        var hdnSelectPlaceName=  $("#hdnSelectPlaceName").val();   
        var hdnSelectSailDate=  $("#hdnSelectSailDate").val();
        var hdnSelectSailId=  $("#hdnSelectSailId").val();

        closeModal(e.target.closest('.modal')); 
        setTripFromSelect($(this).data("rid"), $(this).text(),hdnSelectPlaceId,hdnSelectPlaceType,hdnSelectPlaceName,hdnSelectMode,hdnSelectSailId,hdnSelectSailDate) ;  
      
    })
   
})
        
function onTripSelectOnCreateTrip_callback(modal,rid,name) {
    var rname = name;
    var hdnSelectMode=   $("#hdnSelectMode").val();         
    var hdnSelectPlaceId=   $("#hdnSelectPlaceId").val(); 
    var hdnSelectPlaceType=  $("#hdnSelectPlaceType").val();                    
    var hdnSelectPlaceName=  $("#hdnSelectPlaceName").val(); 
    var hdnSelectSailDate=  $("#hdnSelectSailDate").val();
    var hdnSelectSailId=  $("#hdnSelectSailId").val();
    closeModal(modal);      
    setTripFromSelect(rid, rname,hdnSelectPlaceId,hdnSelectPlaceType,hdnSelectPlaceName,hdnSelectMode,hdnSelectSailId,hdnSelectSailDate) 
}

//open create trip dialog for place add or quick add
function tripSelectOpenCreateTrip(modal) {

    showModal({ 
        url: "/widgets/Trip/Trip-Detail.aspx?m=1&m2=" + $("#hdnSelectMode").val() + "&id=" + $("#hdnSelectPlaceId").val() + "&typ=" + $("#hdnSelectPlaceType").val() + "&n=" + escape($("#hdnSelectPlaceName").val())+ "&sdt=" + escape($("#hdnSelectSailDate").val())+ "&sid=" + escape($("#hdnSelectSailId").val()),       
        saveText: "Save Trip",
        title: "Create Trip", 
        callback: function (modal) {tripSelectOnCreateTrip(modal) } });
    return false;
}

//after trip create, save trip, select the trip, and add the item to the trip
function tripSelectOnCreateTrip(modal) {
    saveTripDetail(modal, onTripSelectOnCreateTrip_callback);    
}
